var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 50,
    viewBox: "0 0 168 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#android)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.233 49.6914H7.44922C4.06597 49.6914 1.29785 46.9136 1.29785 43.5186V6.48153C1.29785 3.08647 4.06597 0.308689 7.44922 0.308689H161.233C164.617 0.308689 167.385 3.08647 167.385 6.48153V43.5186C167.385 46.9136 164.617 49.6914 161.233 49.6914Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.233 0.308689H7.44922C4.06597 0.308689 1.29785 3.08647 1.29785 6.48153V43.5186C1.29785 46.9136 4.06597 49.6914 7.44922 49.6914H161.233C164.617 49.6914 167.385 46.9136 167.385 43.5186V6.48153C167.385 3.08647 164.617 0.308689 161.233 0.308689ZM161.233 1.29634C164.083 1.29634 166.401 3.62276 166.401 6.48153V43.5186C166.401 46.3778 164.083 48.7042 161.233 48.7042H7.44922C4.6004 48.7042 2.28207 46.3778 2.28207 43.5186V6.48153C2.28207 3.62276 4.6004 1.29634 7.44922 1.29634H161.233Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.858 37.3457H135.154V21.9121H132.858V37.3457ZM153.536 27.4716L150.904 34.1629H150.825L148.094 27.4716H145.621L149.717 36.8239L147.382 42.026H149.777L156.089 27.4716H153.536ZM140.517 35.5927C139.764 35.5927 138.716 35.2156 138.716 34.282C138.716 33.0908 140.022 32.6341 141.149 32.6341C142.159 32.6341 142.633 32.8525 143.247 33.1506C143.069 34.58 141.842 35.5927 140.517 35.5927ZM140.794 27.134C139.132 27.134 137.41 27.8689 136.698 29.4971L138.735 30.3506C139.171 29.4971 139.982 29.2188 140.833 29.2188C142.02 29.2188 143.227 29.934 143.247 31.2047V31.3634C142.831 31.1251 141.942 30.7678 140.853 30.7678C138.657 30.7678 136.42 31.9787 136.42 34.2424C136.42 36.3074 138.221 37.6379 140.239 37.6379C141.783 37.6379 142.633 36.943 143.168 36.129H143.247V37.3202H145.463V31.4029C145.463 28.6632 143.425 27.134 140.794 27.134ZM126.606 29.3504H123.341V24.0602H126.606C128.322 24.0602 129.297 25.4861 129.297 26.7052C129.297 27.9013 128.322 29.3504 126.606 29.3504ZM126.547 21.9121H121.047V37.3457H123.341V31.4984H126.547C129.091 31.4984 131.593 29.6499 131.593 26.7052C131.593 23.7606 129.091 21.9121 126.547 21.9121ZM96.5518 35.5956C94.9659 35.5956 93.6381 34.2631 93.6381 32.433C93.6381 30.5836 94.9659 29.2309 96.5518 29.2309C98.1176 29.2309 99.3464 30.5836 99.3464 32.433C99.3464 34.2631 98.1176 35.5956 96.5518 35.5956ZM99.1878 28.3358H99.1085C98.5934 27.7194 97.6019 27.1625 96.3534 27.1625C93.7371 27.1625 91.3391 29.4695 91.3391 32.433C91.3391 35.3767 93.7371 37.664 96.3534 37.664C97.6019 37.664 98.5934 37.1069 99.1085 36.4709H99.1878V37.2266C99.1878 39.2357 98.1176 40.3097 96.3933 40.3097C94.9861 40.3097 94.1139 39.295 93.7568 38.4399L91.7553 39.2752C92.33 40.6674 93.8563 42.3781 96.3933 42.3781C99.0888 42.3781 101.368 40.7866 101.368 36.9083V27.4808H99.1878V28.3358ZM102.954 37.3457H105.253V21.9116H102.954V37.3457ZM108.642 32.2541C108.583 30.2252 110.208 29.1913 111.377 29.1913C112.29 29.1913 113.062 29.6484 113.319 30.3053L108.642 32.2541ZM115.777 30.504C115.342 29.3302 114.013 27.1625 111.298 27.1625C108.602 27.1625 106.363 29.2906 106.363 32.4132C106.363 35.3569 108.583 37.664 111.555 37.664C113.954 37.664 115.342 36.1921 115.916 35.3371L114.132 34.1435C113.538 35.0188 112.725 35.5956 111.555 35.5956C110.386 35.5956 109.554 35.0584 109.018 34.0046L116.015 31.1005L115.777 30.504ZM60.0358 28.7736V31.0011H65.3475C65.1889 32.2541 64.7727 33.1689 64.1384 33.8055C63.3657 34.5814 62.1566 35.4364 60.0358 35.4364C56.7654 35.4364 54.2088 32.7913 54.2088 29.5095C54.2088 26.2278 56.7654 23.5823 60.0358 23.5823C61.7999 23.5823 63.0879 24.2785 64.0394 25.1736L65.6052 23.6025C64.2773 22.3293 62.5131 21.3547 60.0358 21.3547C55.5563 21.3547 51.7905 25.0145 51.7905 29.5095C51.7905 34.0046 55.5563 37.664 60.0358 37.664C62.4541 37.664 64.2773 36.8688 65.7042 35.3767C67.1709 33.9048 67.627 31.8364 67.627 30.166C67.627 29.6484 67.5875 29.1715 67.5078 28.7736H60.0358ZM73.6659 35.5956C72.08 35.5956 70.7123 34.2829 70.7123 32.4132C70.7123 30.5237 72.08 29.2309 73.6659 29.2309C75.2512 29.2309 76.6189 30.5237 76.6189 32.4132C76.6189 34.2829 75.2512 35.5956 73.6659 35.5956ZM73.6659 27.1625C70.7718 27.1625 68.4131 29.3702 68.4131 32.4132C68.4131 35.4364 70.7718 37.664 73.6659 37.664C76.5594 37.664 78.9181 35.4364 78.9181 32.4132C78.9181 29.3702 76.5594 27.1625 73.6659 27.1625ZM85.1237 35.5956C83.5384 35.5956 82.1705 34.2829 82.1705 32.4132C82.1705 30.5237 83.5384 29.2309 85.1237 29.2309C86.7092 29.2309 88.0769 30.5237 88.0769 32.4132C88.0769 34.2829 86.7092 35.5956 85.1237 35.5956ZM85.1237 27.1625C82.2297 27.1625 79.8715 29.3702 79.8715 32.4132C79.8715 35.4364 82.2297 37.664 85.1237 37.664C88.0173 37.664 90.376 35.4364 90.376 32.4132C90.376 29.3702 88.0173 27.1625 85.1237 27.1625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2277 40.2958L14.1363 40.208C13.7783 39.8279 13.5669 39.2376 13.5669 38.4733V38.6532V11.3495C13.5669 11.347 13.5669 11.3452 13.5669 11.3432C13.5669 11.3455 13.5669 11.3475 13.5669 11.35V11.5303C13.5669 10.7027 13.8133 10.0792 14.2262 9.70541L29.469 25.0011L14.2277 40.2958ZM13.5669 11.3417C13.5669 11.2737 13.5687 11.2076 13.5722 11.1426C13.5687 11.2071 13.5669 11.2737 13.5669 11.3417ZM13.5722 11.1396C13.5722 11.1387 13.5722 11.1378 13.5726 11.1368C13.5722 11.1378 13.5722 11.1387 13.5722 11.1396ZM13.5726 11.131C13.5726 11.1305 13.5726 11.13 13.5726 11.1295C13.5726 11.13 13.5726 11.1305 13.5726 11.131Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5494 30.2821L34.6653 30.2161L40.6849 26.7838C41.2588 26.4564 41.6413 26.0595 41.8321 25.6395C41.6418 26.0595 41.2592 26.4569 40.6849 26.7843L34.6653 30.2165L34.5494 30.2821ZM34.5509 30.1012L29.4692 25.001L34.5504 19.9016L40.6849 23.3989C41.4639 23.8431 41.9013 24.4156 41.9744 25.0005C41.9744 25.001 41.9744 25.002 41.9744 25.0028C41.9013 25.5864 41.4639 26.1594 40.6849 26.6035L34.5509 30.1012Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3143 40.8782C14.8885 40.8782 14.5169 40.7393 14.2272 40.4769L14.2277 40.4764C14.5174 40.7388 14.8895 40.8782 15.3153 40.8782C15.3522 40.8782 15.3897 40.8772 15.4277 40.8753C15.3892 40.8772 15.3512 40.8782 15.3143 40.8782ZM15.3148 40.6973C14.889 40.6978 14.5174 40.5584 14.2277 40.2961V40.2957L29.4691 25.001L34.5507 30.1013L16.693 40.2831C16.199 40.5642 15.7309 40.6973 15.3148 40.6973ZM14.2234 40.4736C14.1965 40.449 14.17 40.423 14.144 40.396L14.2234 40.4736Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4692 25.0011L14.2263 9.70542C14.516 9.44357 14.8871 9.30468 15.3124 9.30468C15.7296 9.30468 16.1981 9.43826 16.6931 9.71987L34.5503 19.9017L29.4692 25.0011ZM34.6652 19.7865L16.6931 9.53962C16.1981 9.25789 15.7296 9.12431 15.3124 9.12431C15.3104 9.12431 15.3091 9.12431 15.3071 9.12431C15.3096 9.12431 15.3114 9.12431 15.3144 9.12431C15.7306 9.12431 16.1986 9.25739 16.6931 9.53912L34.6652 19.7865Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4279 40.8754C15.8147 40.8531 16.2429 40.7196 16.6932 40.4635L34.5494 30.2822L16.6932 40.4635C16.2433 40.7201 15.8147 40.8531 15.4279 40.8754ZM14.2274 40.477L14.2236 40.4736C14.2249 40.4746 14.2264 40.476 14.2274 40.477ZM14.1442 40.396L14.1365 40.3883V40.3878C14.1394 40.3907 14.1418 40.3935 14.1442 40.396Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5493 30.2821L34.6656 30.2161L34.5493 30.2821Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3154 40.8782C14.8896 40.8782 14.5176 40.7388 14.2279 40.4764L14.2274 40.4769C14.2264 40.476 14.2249 40.4746 14.2236 40.4736L14.1442 40.396C14.1418 40.3935 14.1394 40.3906 14.1365 40.3878L14.2279 40.2961C14.5176 40.5584 14.8892 40.6978 15.315 40.6973C15.731 40.6973 16.1992 40.5642 16.6932 40.2831L34.5509 30.1013L34.6653 30.2161L34.5494 30.2821L16.6932 40.4635C16.2429 40.7195 15.8147 40.8531 15.4279 40.8753C15.3899 40.8772 15.3524 40.8782 15.3154 40.8782Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1363 40.3883C13.7783 40.0082 13.5669 39.4179 13.5669 38.6536V38.6531C13.5669 39.4179 13.7783 40.0077 14.1363 40.3878V40.3883Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1363 40.3878C13.7783 40.0077 13.5669 39.4179 13.5669 38.6531V38.4733C13.5669 39.2376 13.7783 39.8278 14.1363 40.2079L14.2277 40.2957L14.1363 40.3878Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1365 40.3878L14.2282 40.2957V40.2961L14.1365 40.3878Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.832 25.6395C41.927 25.4311 41.9747 25.2171 41.9747 25.0029C41.9747 25.0025 41.9747 25.002 41.9747 25.002C41.9747 25.2166 41.927 25.4306 41.832 25.6395Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6652 30.2161L34.5508 30.1013L40.6848 26.6035C41.4638 26.1594 41.9012 25.5864 41.9743 25.0029C41.9743 25.2171 41.9266 25.4311 41.832 25.6395C41.6412 26.0595 41.2587 26.4564 40.6848 26.7838L34.6652 30.2161Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9743 25.0011V25.0006C41.9739 24.3548 41.5437 23.7091 40.6849 23.2191L34.6653 19.7869H34.6648L34.6653 19.7865L40.6849 23.2186C41.5447 23.7086 41.9753 24.3553 41.9743 25.0011Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9743 25.0005C41.9012 24.4155 41.4638 23.8431 40.6848 23.3989L34.5503 19.9016L34.6647 19.7868H34.6652L40.6848 23.219C41.5437 23.709 41.9738 24.3547 41.9743 25.0005Z",
    fill: "url(#paint9_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5669 11.3431C13.5669 11.3426 13.5669 11.3422 13.5669 11.3417C13.5669 11.3422 13.5669 11.3426 13.5669 11.3431ZM13.5722 11.1425C13.5722 11.1415 13.5722 11.1405 13.5722 11.1396C13.5722 11.1405 13.5722 11.1415 13.5722 11.1425ZM13.5726 11.1367C13.5726 11.1347 13.5726 11.1329 13.5726 11.1309C13.5726 11.1329 13.5726 11.1347 13.5726 11.1367ZM13.5726 11.1294C13.6438 9.86117 14.331 9.12857 15.3032 9.12425C14.8817 9.12672 14.5146 9.26561 14.2272 9.52549V9.52499L14.2237 9.52845C14.1935 9.55585 14.1647 9.58487 14.1363 9.61474C13.8133 9.95758 13.6096 10.4712 13.5726 11.1294Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5669 11.5303V11.3499C13.5669 11.3474 13.5669 11.3455 13.5669 11.3431C13.5669 11.3426 13.5669 11.3421 13.5669 11.3416C13.5669 11.2736 13.5687 11.2071 13.5722 11.1425C13.5722 11.1415 13.5722 11.1405 13.5722 11.1395C13.5722 11.1387 13.5722 11.1377 13.5726 11.1367C13.5726 11.1347 13.5726 11.1329 13.5726 11.1309C13.5726 11.1304 13.5726 11.1299 13.5726 11.1294C13.6096 10.4711 13.8133 9.95756 14.1363 9.61472L14.2262 9.70534C13.8133 10.0792 13.5669 10.7026 13.5669 11.5303ZM14.2237 9.52842L14.2272 9.52497C14.2262 9.52645 14.2247 9.52743 14.2237 9.52842Z",
    fill: "url(#paint10_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5504 19.9016L16.6932 9.71976C16.1982 9.43816 15.7297 9.30457 15.3125 9.30457C14.8872 9.30457 14.5161 9.44346 14.2264 9.70532L14.1365 9.6147C14.1649 9.58482 14.1937 9.55581 14.2239 9.5284C14.2249 9.52741 14.2264 9.52643 14.2274 9.52544C14.5148 9.26556 14.8819 9.12667 15.3034 9.1242C15.3044 9.1242 15.3057 9.1242 15.3072 9.1242C15.3092 9.1242 15.3105 9.1242 15.3125 9.1242C15.7297 9.1242 16.1982 9.25778 16.6932 9.53951L34.6653 19.7864L34.6648 19.7868L34.5504 19.9016Z",
    fill: "url(#paint11_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.007 13.4606H56.4603L55.254 10.1196H55.2132L54.007 13.4606ZM51.9141 16.358L54.6976 8.95063H55.7692L58.5532 16.358H57.5017L56.7905 14.3504H53.6874L52.9651 16.358H51.9141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0071 13.4607V13.5842H56.6358L55.3402 9.99626H55.2132H55.1267L53.8316 13.5842H54.0071V13.4607L54.1228 13.5032L55.3291 10.1617L55.2132 10.1197V10.2432H55.2541V10.1197L55.1383 10.1617L56.2849 13.3372H54.0071V13.4607L54.1228 13.5032L54.0071 13.4607ZM51.9141 16.3581L52.0289 16.4016L54.7826 9.07416H55.6842L58.3754 16.2347H57.5888L56.8775 14.227H53.6009L52.8791 16.2347H51.9141V16.3581L52.0289 16.4016L51.9141 16.3581V16.4816H52.9651H53.0516L53.7734 14.4739H56.7039L57.4153 16.4816H58.5533H58.7311L55.8543 8.82725H54.6976H54.6125L51.7363 16.4816H51.9141V16.3581Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8939 16.5236C61.8078 16.5236 60.8971 16.1547 60.1618 15.4163C59.4256 14.6785 59.0588 13.7578 59.0588 12.6544C59.0588 11.551 59.4256 10.6303 60.1618 9.89257C60.8971 9.15418 61.8078 8.78479 62.8939 8.78479C64.0064 8.78479 64.9112 9.1885 65.6057 9.99529L64.945 10.6371C64.4437 10.0092 63.7589 9.69578 62.8939 9.69578C62.0889 9.69578 61.4103 9.96825 60.8576 10.5132C60.3035 11.0581 60.0272 11.772 60.0272 12.6544C60.0272 13.5369 60.3035 14.2512 60.8576 14.7957C61.4103 15.3406 62.0889 15.6131 62.8939 15.6131C63.7805 15.6131 64.5365 15.2547 65.1621 14.5376L65.822 15.1992C65.4842 15.6063 65.0627 15.9289 64.5532 16.1662C64.0448 16.4044 63.4911 16.5236 62.8939 16.5236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8938 16.5235V16.4001C61.8356 16.3986 60.9634 16.0441 60.2487 15.3289C59.5351 14.6128 59.1833 13.7303 59.1818 12.6544C59.1833 11.5785 59.5351 10.696 60.2487 9.97981C60.9634 9.26413 61.8356 8.90969 62.8938 8.90821C63.9771 8.91018 64.8383 9.295 65.5125 10.0757L65.6057 9.99524L65.5202 9.90648L64.8594 10.5488L64.9449 10.6371L65.041 10.5599C64.5191 9.90315 63.7882 9.57043 62.8938 9.57228C62.0614 9.57129 61.3444 9.85833 60.7711 10.4249L60.7678 10.4288L60.7716 10.4249C60.1925 10.9935 59.9032 11.7467 59.9041 12.6544C59.9032 13.562 60.1925 14.3162 60.7716 14.8839H60.7711C61.3444 15.4504 62.0614 15.7375 62.8938 15.7365C63.8141 15.738 64.6114 15.3588 65.2549 14.6191L65.1621 14.5376L65.0751 14.6249L65.735 15.2865L65.822 15.1992L65.7273 15.1207C65.4015 15.5131 64.9959 15.8238 64.5013 16.0543C64.0097 16.2847 63.4749 16.3996 62.8938 16.4001V16.5235V16.647C63.507 16.647 64.0799 16.5245 64.6051 16.2781C65.1295 16.034 65.5672 15.6998 65.9161 15.2783L65.9882 15.192L65.2492 14.4503L65.1564 14.3567L65.0698 14.4561C64.461 15.151 63.7469 15.4881 62.8938 15.4896C62.1168 15.4881 61.4757 15.2306 60.9436 14.7073C60.4151 14.1865 60.1517 13.5118 60.1502 12.6544C60.1517 11.797 60.4151 11.1233 60.9436 10.6014C61.4757 10.0782 62.1168 9.82068 62.8938 9.81919C63.7301 9.82117 64.3687 10.1154 64.8489 10.7143L64.9334 10.8204L65.6912 10.084L65.7749 10.0029L65.699 9.91475C64.9838 9.08142 64.0357 8.65994 62.8938 8.66129C61.7803 8.66031 60.8312 9.04475 60.0748 9.80524C59.3155 10.5643 58.9348 11.524 58.9358 12.6544C58.9348 13.7847 59.3155 14.7445 60.0748 15.504C60.8312 16.264 61.7803 16.648 62.8938 16.647V16.5235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7084 16.5236C68.8962 16.5236 68.2392 16.2544 67.7332 15.7168C67.2285 15.179 66.9763 14.4749 66.9763 13.6064V8.95072H67.9245V13.6479C67.9245 14.2338 68.0768 14.7079 68.3834 15.0705C68.6886 15.4322 69.1307 15.6131 69.7084 15.6131C70.285 15.6131 70.7272 15.4322 71.0323 15.0705C71.339 14.7079 71.4913 14.2338 71.4913 13.6479V8.95072H72.4405V13.6064C72.4405 14.4822 72.1944 15.1878 71.7028 15.7216C71.2115 16.2569 70.546 16.5236 69.7084 16.5236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7084 16.5235V16.4001C68.9231 16.3981 68.3065 16.1445 67.8225 15.6318H67.823C67.3419 15.1187 67.1002 14.4518 67.0993 13.6064V9.07413H67.8014V13.6478C67.801 14.2545 67.9609 14.7618 68.2891 15.1506C68.6198 15.5435 69.1066 15.738 69.7084 15.7365C70.3095 15.738 70.7958 15.5435 71.1265 15.1501C71.4547 14.7618 71.6148 14.2545 71.6143 13.6478V9.07413H72.3174V13.6064C72.3169 14.4594 72.08 15.1288 71.6123 15.6376C71.1447 16.1454 70.5205 16.3986 69.7084 16.4001V16.5235V16.647C70.5709 16.648 71.2783 16.3677 71.7936 15.805C72.3087 15.246 72.5643 14.5043 72.5635 13.6064V8.82722H71.4913H71.3683V13.6478C71.3678 14.213 71.2226 14.6533 70.9386 14.9909C70.6584 15.3208 70.261 15.4881 69.7084 15.4896C69.1547 15.4881 68.7572 15.3208 68.4771 14.9909C68.1926 14.6533 68.048 14.213 68.0475 13.6478V8.82722H66.9763H66.8533V13.6064C66.8523 14.4981 67.1151 15.2392 67.6437 15.801C68.1714 16.3644 68.8697 16.648 69.7084 16.647V16.5235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9663 16.358V8.95063H74.9145L77.4817 13.4606H77.5225L80.0903 8.95063H81.0379V16.358H80.0903V11.9614L80.1311 10.719H80.0903L77.7811 14.7859H77.2237L74.9145 10.719H74.8736L74.9145 11.9614V16.358H73.9663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9663 16.3581H74.0893V9.07416H74.8429L77.4106 13.5842H77.5225H77.5941L80.1613 9.07416H80.9149V16.2347H80.2133V11.9628L80.2541 10.7234L80.258 10.5956H80.0902H80.0186L77.7095 14.6626H77.2953L74.9856 10.5956H74.8736H74.7463L74.7914 11.9633V16.2347H73.9663V16.3581H74.0893H73.9663V16.4816H74.9145H75.0375V11.959L74.9966 10.7153L74.8736 10.7191V10.8426H74.9145V10.7191L74.8073 10.7803L77.1521 14.9095H77.7811H77.8527L80.197 10.7803L80.0902 10.7191V10.8426H80.1311V10.7191L80.008 10.7153L79.9672 11.9571V11.959V16.4816H81.0379H81.1609V8.82725H80.0902H80.0186L77.4158 13.3995L77.5225 13.4607V13.3372H77.4817V13.4607L77.5883 13.3995L74.9856 8.82725H73.9663H73.8433V16.4816H73.9663V16.3581Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1508 12.4469H87.7391C88.1379 12.4469 88.4576 12.3128 88.6978 12.0443C88.9381 11.7747 89.0583 11.479 89.0583 11.1546C89.0583 10.8305 88.9381 10.5333 88.6978 10.2648C88.4576 9.99519 88.1379 9.86063 87.7391 9.86063H86.1508V12.4469ZM86.1508 16.358H85.2031V8.95063H87.7184C88.3431 8.95063 88.8853 9.1589 89.3419 9.57606C89.7993 9.99322 90.0281 10.5199 90.0281 11.1546C90.0281 11.7886 89.7993 12.3143 89.3419 12.7315C88.8853 13.1491 88.3431 13.3579 87.7184 13.3579H86.1508V16.358Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1508 12.447V12.5705H87.7391C88.1649 12.5719 88.5268 12.4224 88.7896 12.1269C89.0462 11.8398 89.1823 11.51 89.1813 11.1547C89.1823 10.7992 89.0462 10.4689 88.7896 10.1824C88.5272 9.88577 88.1649 9.73577 87.7391 9.73725H86.1508H86.0277V12.5705H86.1508V12.447H86.2738V9.98416H87.7391C88.1111 9.98614 88.3879 10.1048 88.606 10.3472H88.6065C88.8295 10.5986 88.9343 10.8614 88.9353 11.1547C88.9343 11.4479 88.8299 11.7097 88.606 11.9619H88.6065C88.3884 12.204 88.1111 12.3222 87.7391 12.3235H86.1508V12.447H86.2738H86.1508ZM86.1508 16.3581V16.2347H85.3261V9.07416H87.7184C88.3163 9.07515 88.8228 9.27046 89.2592 9.66786C89.6926 10.0647 89.9031 10.5493 89.9051 11.1547C89.9031 11.7589 89.6926 12.243 89.2592 12.6405C88.8228 13.0382 88.3163 13.2335 87.7184 13.2345H86.1508H86.0277V16.3581H86.1508V16.2347V16.3581H86.2738V13.4814H87.7184C88.3706 13.4824 88.9477 13.2601 89.4244 12.8227C89.9064 12.3858 90.1525 11.8186 90.1511 11.1547C90.1525 10.4901 89.9064 9.92243 89.4244 9.48503C88.9477 9.04811 88.3706 8.82626 87.7184 8.82725H85.0801V16.4816H86.1508H86.2738V16.3581H86.1508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.534 9.86063H92.1723V12.2093H95.2038V13.0994H92.1723V15.448H95.534V16.358H91.2241V8.95063H95.534V9.86063Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.534 9.8607V9.73725H92.0492V12.3328H95.0808V12.9756L92.0492 12.976V15.5716H95.411V16.2347H91.3471V9.07416H95.411V9.8607H95.534V9.73725V9.8607H95.657V8.9507V8.82725H91.1011V16.4816H95.657V15.4481V15.3247H92.2953V13.2229H95.3268V12.2093V12.0859H92.2953V9.98416H95.657V9.8607H95.534Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 28.1175,
    y1: 11.0615,
    x2: 7.39846,
    y2: 31.7084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 42.9235,
    y1: 25.0017,
    x2: 13.1546,
    y2: 25.0017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 31.8418,
    y1: 27.8347,
    x2: 3.74528,
    y2: 55.8335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 10.2755,
    y1: 0.526284,
    x2: 22.8218,
    y2: 13.0289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 42.9525,
    y1: 25.0016,
    x2: 13.0801,
    y2: 25.0016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#CC9700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#CC8400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 31.842,
    y1: 27.8347,
    x2: 3.74547,
    y2: 55.8335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC2E36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C0E4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 28.1175,
    y1: 11.0614,
    x2: 7.39847,
    y2: 31.7084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008DE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#008DE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00A7E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00B8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00C4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 31.9041,
    y1: 27.8353,
    x2: 3.80875,
    y2: 55.9325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0333C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB0F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 42.9234,
    y1: 25.0017,
    x2: 13.1545,
    y2: 25.0017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0C500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#E0A600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#E09100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E08900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 42.9234,
    y1: 25.0017,
    x2: 13.1545,
    y2: 25.0017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFCE40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFBC40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB540"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 28.1174,
    y1: 11.0614,
    x2: 7.39843,
    y2: 31.7083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#40B9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#40CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#40DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#40E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40EAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 10.2756,
    y1: 0.52618,
    x2: 22.8218,
    y2: 13.0288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65B895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#62BD95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#50DB97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#44ED98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F498"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "android"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 167.01,
    height: 50,
    fill: "white",
    transform: "translate(0.990234)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.4937bf18677879ac258e7df2f4379525.svg";
export { ForwardRef as ReactComponent };